var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeVotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6894 10.6491L14.6874 10.646L11.7496 6.08599L8.81394 10.6427C8.81349 10.6434 8.81303 10.6441 8.81257 10.6448C8.62417 10.9382 8.33337 11.1713 7.97578 11.2806L14.6894 10.6491ZM14.6894 10.6491C14.8784 10.9407 15.1687 11.1719 15.5248 11.2805C15.8829 11.3897 16.2658 11.3613 16.6019 11.2051L16.6019 11.2051L16.6123 11.2001L20.033 9.57044M14.6894 10.6491L20.033 9.57044M20.033 9.57044L17.6802 18.2115H5.81983L3.46701 9.57044L6.88768 11.2001L6.88768 11.2001L6.89226 11.2023C7.22961 11.3613 7.61525 11.3908 7.97578 11.2806L20.033 9.57044Z",
    stroke: "#111827",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 6.19617L8.72817 11.0279L3.01794 8.83166L6.09268 18.9344H17.5131L20.5879 8.83166L15.3169 11.0279L11.8029 6.19617Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeVotes);
export default __webpack_public_path__ + "static/media/freeVotes.6b5ad183aaecce08c83ba05fe2ad147b.svg";
export { ForwardRef as ReactComponent };